import user from './modules/user';
import common from './modules/common';
import guild from './modules/guild';
import agent from './modules/agent';
import pay from './modules/pay';

export default {
  user,
  common,
  guild,
  agent,
  pay,
};
